import { useQuery } from '@tanstack/react-query';
import { fetchUser } from '@/lib/api/user';
import { useMemo } from 'react';
import { isAxiosError } from 'axios';
import { QUERY_KEYS } from '@/lib';
import { debounce } from 'lodash';

// TODO: Validate that enabled is needed -> currently enabled just makes it so that the query will not attempt to fetch without authentication
export function useUser(enabled = true) {
    const {
        data: user,
        isLoading: isUserLoading,
        error,
        refetch,
    } = useQuery({
        queryKey: [QUERY_KEYS.USER],
        queryFn: fetchUser,
        staleTime: 1000 * 60 * 10, // 5 minutes
        enabled,
        retry: false,
    });

    // add debounce to this call
    const refetchUser = useMemo(() => debounce(refetch, 300), [refetch]);

    const errorMessage = error
        ? isAxiosError(error)
            ? error.response?.data?.message || error?.response?.data?.error || 'Failed to fetch user data'
            : error instanceof Error
              ? error.message
              : 'Failed to fetch user data'
        : undefined;

    if (isAxiosError(error) && error.response?.status === 401) {
        // Let auth store handle token cleanup
        throw error;
    }

    return { user, isUserLoading, errorMessage, refetchUser };
}
